import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logEvent } from '../utils/analytics';
import './Feedback.css';
import './Dashboard.css';

const API_BASE_URL = '/api';

function FeedbackPage() {
  const navigate = useNavigate();
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submissionId, setSubmissionId] = useState(null);
  const [characterCount, setCharacterCount] = useState(0);
  const [userData, setUserData] = useState(null);
  const [activeMenu, setActiveMenu] = useState('feedback');

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/doctor-auth/check-session`, {
        credentials: 'include'
      });
      const data = await response.json();
      if (data.authenticated && data.data && data.data.doctor) {
        setUserData(data.data.doctor);
      } else {
        navigate('/login');
      }
    } catch (error) {
      console.error('Error checking session:', error);
      navigate('/login');
    }
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE_URL}/doctor-auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
      navigate('/login');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  const handleMenuClick = (menuItem) => {
    setActiveMenu(menuItem);
    if (menuItem === 'home') {
      // For doctors, home = AI chat; for students, home = dashboard
      if (userData?.user_type === 'doctor') {
        navigate('/chat');
      } else {
        navigate('/dashboard');
      }
    } else if (menuItem === 'ai-chat') {
      navigate('/chat');
    } else if (menuItem === 'exams') {
      navigate('/exams');
    } else if (menuItem === 'feedback') {
      navigate('/feedback');
    } else if (menuItem === 'profile') {
      navigate('/edit-profile');
    }
  };

  const getMenuItems = () => {
    if (!userData) return [];

    if (userData.user_type === 'medical_student') {
      return [
        { id: 'home', label: 'Home', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg> },
        { id: 'ai-chat', label: 'AI Chat', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg> },
        { id: 'exams', label: 'Exams', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 19V5C4 3.89543 4.89543 3 6 3H19.4C19.7314 3 20 3.26863 20 3.6V16.7143" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M6 17L20 17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M6 21L20 21" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M6 21C4.89543 21 4 20.1046 4 19C4 17.8954 4.89543 17 6 17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 7L15 7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg> },
        { id: 'feedback', label: 'Feedback', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg> },
        { id: 'profile', label: 'Profile', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg> }
      ];
    } else {
      return [
        { id: 'home', label: 'AI Chat', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg> },
        { id: 'feedback', label: 'Feedback', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg> },
        { id: 'profile', label: 'Profile', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg> }
      ];
    }
  };

  const handleMessageChange = (e) => {
    const value = e.target.value;
    if (value.length <= 1000) {
      setMessage(value);
      setCharacterCount(value.length);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (rating === 0) {
      setError('Please select a rating');
      return;
    }

    if (message.length < 10) {
      setError('Message must be at least 10 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/feedback/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ rating, message })
      });

      const data = await response.json();

      if (data.success) {
        // Track feedback submission
        logEvent('Feedback', 'feedback_submitted', {
          rating: rating,
          has_message: message.trim().length > 0,
          message_length: message.trim().length,
          user_type: userData?.user_type,
        });

        setSuccess(true);
        setSubmissionId(data.submissionId);
        setRating(0);
        setMessage('');
        setCharacterCount(0);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        setError(data.message || 'An error occurred. Please try again.');
      }
    } catch (err) {
      console.error('Feedback submission error:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!userData) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  const menuItems = getMenuItems().filter(item => item.id !== 'profile');

  return (
    <div className="dashboard-container">
      {/* Top Header */}
      <div className="dashboard-header">
        <div className="dashboard-header-left">
          <img src="/logo.svg" alt="S.C.A.L.P.E.L. Logo" className="dashboard-logo-img" />
        </div>
        <nav className="dashboard-nav desktop-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`nav-menu-item ${activeMenu === item.id ? 'active' : ''}`}
              onClick={() => handleMenuClick(item.id)}
            >
              <span className="nav-menu-icon">{item.icon}</span>
              <span className="nav-menu-label">{item.label}</span>
            </button>
          ))}
        </nav>
        <button onClick={handleLogout} className="dashboard-logout-btn">
          <svg width="20" height="20" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
            <path d="M12 12H19M19 12L16 15M19 12L16 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M19 6V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V18" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <span className="logout-text">Logout</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="feedback-page-content">
        <div className="feedback-container">
          {/* Header Section */}
          <div className="feedback-header-section">
            <div className="feedback-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              Feedback
            </div>
            <h1 className="feedback-main-heading">Share Your Feedback</h1>
            <p className="feedback-subheading">
              Help us improve S.C.A.L.P.E.L. by sharing your thoughts and suggestions.
            </p>
          </div>

          {/* Success Message */}
          {success && (
            <div className="success-message-box">
              <div className="success-icon">✓</div>
              <h3>Thank You!</h3>
              <p>Your feedback has been received successfully.</p>
              {submissionId && <p className="submission-id">Submission ID: #{submissionId}</p>}
              <p className="success-note">We appreciate your input and will use it to improve our platform.</p>
            </div>
          )}

          {/* Error Message */}
          {error && (
            <div className="error-message-box">
              <div className="error-icon">✕</div>
              <p>{error}</p>
            </div>
          )}

          {/* Feedback Form */}
          <div className="feedback-form-wrapper">
            <form className="feedback-form" onSubmit={handleSubmit}>
              {/* Star Rating */}
              <div className="form-group">
                <label htmlFor="rating">
                  Rating <span className="required">*</span>
                </label>
                <div className="star-rating-container">
                  <div className="star-rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <svg
                        key={star}
                        className={`star ${star <= (hoverRating || rating) ? 'star-filled' : 'star-empty'}`}
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        onClick={() => setRating(star)}
                        onMouseEnter={() => setHoverRating(star)}
                        onMouseLeave={() => setHoverRating(0)}
                      >
                        <path
                          d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                          fill={star <= (hoverRating || rating) ? '#FFB800' : 'none'}
                          stroke="#FFB800"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ))}
                  </div>
                  {rating > 0 && (
                    <p className="rating-text">
                      {rating === 1 && 'Poor'}
                      {rating === 2 && 'Fair'}
                      {rating === 3 && 'Good'}
                      {rating === 4 && 'Very Good'}
                      {rating === 5 && 'Excellent'}
                    </p>
                  )}
                </div>
              </div>

              {/* Message */}
              <div className="form-group">
                <label htmlFor="message">
                  Your Feedback <span className="required">*</span>
                  <span className="char-count">{characterCount}/1000</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={message}
                  onChange={handleMessageChange}
                  rows="8"
                  required
                  minLength={10}
                  maxLength={1000}
                  placeholder="Tell us what you think about S.C.A.L.P.E.L. What do you like? What can we improve?"
                ></textarea>
              </div>

              {/* Submit Button */}
              <button type="submit" className="feedback-submit-btn" disabled={loading || rating === 0}>
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Submitting...
                  </>
                ) : (
                  <>
                    <span>Submit Feedback</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Info Section */}
          <div className="feedback-info">
            <div className="info-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <p>Your feedback helps us improve the platform for everyone</p>
            </div>
            <div className="info-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <p>All feedback is reviewed by our team</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeedbackPage;
